import React from "react";

import LandingLayout from "components/common/landingLayout";
import PrivacyPolicy from "components/privacyPolicy";

const PrivacyPolicyPage = () => {
  return (
    <LandingLayout>
      <PrivacyPolicy />
    </LandingLayout>
  );
};
export default PrivacyPolicyPage;
